// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Theme__Color$PrezzeeRibbon from "../../../theme/Theme__Color.bs.js";

function t(headingColorOpt, descriptionColorOpt, deselectedColorOpt, selectedTextColorOpt, selectedBackgroundColorOpt, selectedIconBorderColorOpt, param) {
  var headingColor = headingColorOpt !== undefined ? headingColorOpt : Theme__Color$PrezzeeRibbon.gray800;
  var descriptionColor = descriptionColorOpt !== undefined ? descriptionColorOpt : Theme__Color$PrezzeeRibbon.gray600;
  var deselectedColor = deselectedColorOpt !== undefined ? deselectedColorOpt : Theme__Color$PrezzeeRibbon.gray800;
  var selectedTextColor = selectedTextColorOpt !== undefined ? selectedTextColorOpt : Theme__Color$PrezzeeRibbon.blue400;
  var selectedBackgroundColor = selectedBackgroundColorOpt !== undefined ? selectedBackgroundColorOpt : Theme__Color$PrezzeeRibbon.blue50;
  var selectedIconBorderColor = selectedIconBorderColorOpt !== undefined ? selectedIconBorderColorOpt : Theme__Color$PrezzeeRibbon.blue400;
  return {
          headingColor: headingColor,
          descriptionColor: descriptionColor,
          deselectedColor: deselectedColor,
          selectedTextColor: selectedTextColor,
          selectedBackgroundColor: selectedBackgroundColor,
          selectedIconBorderColor: selectedIconBorderColor
        };
}

export {
  t ,
}
/* Theme__Color-PrezzeeRibbon Not a pure module */
